import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PlatetscService {

  private dataTSCcods:any = [
    
    { seo_val: '', text_val: 'тсц' },

    //АР КРим
    { seo_val: '12306', text_val: 'РСЦ МВС АР Крим та м. Севастополь', filterForReg: '1' },

    //Вінницька область
    { seo_val: '12228', text_val: 'РСЦ МВС у Вінницькій області', filterForReg: '2' },
    { seo_val: '12229', text_val: 'ТСЦ МВС 0541', filterForReg: '2' }, 
    { seo_val: '12230', text_val: 'ТСЦ МВС 0542', filterForReg: '2' }, 
    { seo_val: '12231', text_val: 'ТСЦ МВС 0543', filterForReg: '2' }, 
    { seo_val: '12232', text_val: 'ТСЦ МВС 0544', filterForReg: '2' }, 
    { seo_val: '12233', text_val: 'ТСЦ МВС 0545', filterForReg: '2' }, 
    { seo_val: '13659', text_val: 'ТСЦ МВС 0546', filterForReg: '2' }, 
    
    //Волинська область
    { seo_val: '12234', text_val: 'РСЦ МВС у Волинській області', filterForReg: '3' },
    { seo_val: '12235', text_val: 'ТСЦ МВС 0741', filterForReg: '3' }, 
    { seo_val: '12236', text_val: 'ТСЦ МВС 0742', filterForReg: '3' },
    { seo_val: '12237', text_val: 'ТСЦ МВС 0743', filterForReg: '3' },
    { seo_val: '12238', text_val: 'ТСЦ МВС 0744', filterForReg: '3' },
    
    //Дніпропетровська область
    { seo_val: '12239', text_val: 'РСЦ МВС у Дніпропетровська області', filterForReg: '4' },
    { seo_val: '12240', text_val: 'ТСЦ МВС 1241', filterForReg: '4' },
    { seo_val: '12241', text_val: 'ТСЦ МВС 1242', filterForReg: '4' },
    { seo_val: '12242', text_val: 'ТСЦ МВС 1243', filterForReg: '4' },
    { seo_val: '12243', text_val: 'ТСЦ МВС 1244', filterForReg: '4' },
    { seo_val: '12244', text_val: 'ТСЦ МВС 1245', filterForReg: '4' },
    { seo_val: '12245', text_val: 'ТСЦ МВС 1246', filterForReg: '4' },
    { seo_val: '12246', text_val: 'ТСЦ МВС 1247', filterForReg: '4' },
    { seo_val: '12537', text_val: 'ТСЦ МВС 1248', filterForReg: '4' },
    { seo_val: '13648', text_val: 'ТСЦ МВС 1249', filterForReg: '4' },

    //Донецька область
    { seo_val: '12247', text_val: 'РСЦ МВС у Донецькій області', filterForReg: '5' },
    { seo_val: '12248', text_val: 'ТСЦ МВС 1441', filterForReg: '5' },
    { seo_val: '12249', text_val: 'ТСЦ МВС 1442', filterForReg: '5' },
    { seo_val: '12250', text_val: 'ТСЦ МВС 1443', filterForReg: '5' },
    { seo_val: '12251', text_val: 'ТСЦ МВС 1444', filterForReg: '5' },
    { seo_val: '12252', text_val: 'ТСЦ МВС 1445', filterForReg: '5' },

    //Житомирська область
    { seo_val: '12253', text_val: 'РСЦ МВС у Житомирській області', filterForReg: '6' },
    { seo_val: '12254', text_val: 'ТСЦ МВС 1841', filterForReg: '6' },
    { seo_val: '12255', text_val: 'ТСЦ МВС 1842', filterForReg: '6' },
    { seo_val: '12256', text_val: 'ТСЦ МВС 1843', filterForReg: '6' },
    { seo_val: '12257', text_val: 'ТСЦ МВС 1844', filterForReg: '6' },
    { seo_val: '12258', text_val: 'ТСЦ МВС 1845', filterForReg: '6' },

    //Закарпатська область
    { seo_val: '12259', text_val: 'РСЦ МВС у Закарпатській області', filterForReg: '7' },
    { seo_val: '12261', text_val: 'ТСЦ МВС 2141', filterForReg: '7' },    
    { seo_val: '12262', text_val: 'ТСЦ МВС 2142', filterForReg: '7' },
    { seo_val: '12263', text_val: 'ТСЦ МВС 2143', filterForReg: '7' },
    { seo_val: '12264', text_val: 'ТСЦ МВС 2144', filterForReg: '7' },
    { seo_val: '12265', text_val: 'ТСЦ МВС 2145', filterForReg: '7' },
    { seo_val: '12396', text_val: 'ТСЦ МВС 2146', filterForReg: '7' },

    //Запорізька область
    { seo_val: '12266', text_val: 'РСЦ МВС у Запорізькій області', filterForReg: '8' },
    { seo_val: '12267', text_val: 'ТСЦ МВС 2341', filterForReg: '8' }, 
    { seo_val: '12268', text_val: 'ТСЦ МВС 2342', filterForReg: '8' },
    { seo_val: '12269', text_val: 'ТСЦ МВС 2343', filterForReg: '8' },
    { seo_val: '12270', text_val: 'ТСЦ МВС 2344', filterForReg: '8' },
    { seo_val: '12271', text_val: 'ТСЦ МВС 2345', filterForReg: '8' },
    { seo_val: '12272', text_val: 'ТСЦ МВС 2346', filterForReg: '8' },
    { seo_val: '12273', text_val: 'ТСЦ МВС 2347', filterForReg: '8' }, 
    
    //Івано-Франківська область
    { seo_val: '12275', text_val: 'РСЦ МВС у Івано-Франківській області', filterForReg: '9' },
    { seo_val: '12276', text_val: 'ТСЦ МВС 2641', filterForReg: '9' },
    { seo_val: '12277', text_val: 'ТСЦ МВС 2642', filterForReg: '9' },    
    { seo_val: '12278', text_val: 'ТСЦ МВС 2643', filterForReg: '9' },    
    { seo_val: '13968', text_val: 'ТСЦ МВС 2644', filterForReg: '9' }, 

    //Київ
    { seo_val: '12289', text_val: 'РСЦ МВС у м. Києві', filterForReg: '26' },
    { seo_val: '12290', text_val: 'ТСЦ МВС 8041', filterForReg: '26' },
    { seo_val: '12291', text_val: 'ТСЦ МВС 8042', filterForReg: '26' },    
    { seo_val: '12292', text_val: 'ТСЦ МВС 8043', filterForReg: '26' },    
    { seo_val: '12293', text_val: 'ТСЦ МВС 8044', filterForReg: '26' }, 
    { seo_val: '12295', text_val: 'ТСЦ МВС 8045', filterForReg: '26' },    
    { seo_val: '12296', text_val: 'ТСЦ МВС 8046', filterForReg: '26' },    
    { seo_val: '12297', text_val: 'ТСЦ МВС 8047', filterForReg: '26' },
    { seo_val: '12298', text_val: 'ТСЦ МВС 8048', filterForReg: '26' }, 
    
    //Київська область
    { seo_val: '12279', text_val: 'РСЦ МВС у Київській області', filterForReg: '10' },
    { seo_val: '12280', text_val: 'ТСЦ МВС 3241', filterForReg: '10' },
    { seo_val: '12281', text_val: 'ТСЦ МВС 3242', filterForReg: '10' },
    { seo_val: '12282', text_val: 'ТСЦ МВС 3243', filterForReg: '10' },
    { seo_val: '12283', text_val: 'ТСЦ МВС 3244', filterForReg: '10' },
    { seo_val: '12284', text_val: 'ТСЦ МВС 3245', filterForReg: '10' },
    { seo_val: '12285', text_val: 'ТСЦ МВС 3246', filterForReg: '10' },
    { seo_val: '12286', text_val: 'ТСЦ МВС 3247', filterForReg: '10' },
    { seo_val: '12287', text_val: 'ТСЦ МВС 3248', filterForReg: '10' },
    { seo_val: '12288', text_val: 'ТСЦ МВС 3249', filterForReg: '10' },
    
    //Кіровоградська область
    { seo_val: '12297', text_val: 'РСЦ МВС у Кіровоградській області', filterForReg: '11' },
    { seo_val: '12298', text_val: 'ТСЦ МВС 3541', filterForReg: '11' },    
    { seo_val: '12299', text_val: 'ТСЦ МВС 3542', filterForReg: '11' },  
    { seo_val: '12300', text_val: 'ТСЦ МВС 3543', filterForReg: '11' },  
    { seo_val: '12394', text_val: 'ТСЦ МВС 3544', filterForReg: '11' },  
    { seo_val: '12395', text_val: 'ТСЦ МВС 3545', filterForReg: '11' },  

    //Луганська область
    { seo_val: '12301', text_val: 'РСЦ МВС у Луганській області', filterForReg: '12' },
    { seo_val: '12302', text_val: 'ТСЦ МВС 4441', filterForReg: '12' },  
    { seo_val: '12303', text_val: 'ТСЦ МВС 4442', filterForReg: '12' },  
    { seo_val: '12304', text_val: 'ТСЦ МВС 4443', filterForReg: '12' },  
    { seo_val: '12305', text_val: 'ТСЦ МВС 4444', filterForReg: '12' },     

    // Львівська область
    // { seo_val: '', text_val: 'тсц', filterForReg: '13' },
    { seo_val: '12306', text_val: 'РСЦ МВС у Львівській області', filterForReg: '13' }, 
    { seo_val: '12307', text_val: 'ТСЦ МВС 4641', filterForReg: '13' }, 
    { seo_val: '12308', text_val: 'ТСЦ МВС 4642', filterForReg: '13' }, 
    { seo_val: '12309', text_val: 'ТСЦ МВС 4643', filterForReg: '13' }, 
    { seo_val: '12310', text_val: 'ТСЦ МВС 4644', filterForReg: '13' }, 
    { seo_val: '12311', text_val: 'ТСЦ МВС 4645', filterForReg: '13' }, 
    { seo_val: '12312', text_val: 'ТСЦ МВС 4646', filterForReg: '13' }, 
    { seo_val: '12313', text_val: 'ТСЦ МВС 4647', filterForReg: '13' }, 
    { seo_val: '13466', text_val: 'ТСЦ МВС 4648', filterForReg: '13' }, 
    
    // Миколаївська область
    { seo_val: '12314', text_val: 'РСЦ МВС у Миколаївській області', filterForReg: '14'},
    { seo_val: '12315', text_val: 'ТСЦ МВС 4841', filterForReg: '14' }, 
    { seo_val: '12316', text_val: 'ТСЦ МВС 4842', filterForReg: '14' }, 
    { seo_val: '12317', text_val: 'ТСЦ МВС 4843', filterForReg: '14' }, 
    { seo_val: '12318', text_val: 'ТСЦ МВС 4844', filterForReg: '14' }, 
    { seo_val: '12319', text_val: 'ТСЦ МВС 4845', filterForReg: '14' }, 
    
    // Одеська область
    { seo_val: '12320', text_val: 'РСЦ МВС у Одеській області', filterForReg: '15'}, 
    { seo_val: '12321', text_val: 'ТСЦ МВС 5141', filterForReg: '15' }, 
    { seo_val: '12322', text_val: 'ТСЦ МВС 5142', filterForReg: '15' }, 
    { seo_val: '12323', text_val: 'ТСЦ МВС 5143', filterForReg: '15' }, 
    { seo_val: '12324', text_val: 'ТСЦ МВС 5144', filterForReg: '15' },
    { seo_val: '12325', text_val: 'ТСЦ МВС 5146', filterForReg: '15' }, 
    { seo_val: '12326', text_val: 'ТСЦ МВС 5147', filterForReg: '15' }, 
    { seo_val: '12327', text_val: 'ТСЦ МВС 5148', filterForReg: '15' }, 
    { seo_val: '12328', text_val: 'ТСЦ МВС 5149', filterForReg: '15' }, 
    { seo_val: '12393', text_val: 'ТСЦ МВС 5145', filterForReg: '15' }, 
    { seo_val: '13362', text_val: 'ТСЦ МВС 5150', filterForReg: '15' }, 
    { seo_val: '13364', text_val: 'ТСЦ МВС 5151', filterForReg: '15' }, 
    { seo_val: '13747', text_val: 'ТСЦ МВС 5152', filterForReg: '15' }, 
    { seo_val: '13843', text_val: 'ТСЦ МВС 5153', filterForReg: '15' }, 
    { seo_val: '14012', text_val: 'ТСЦ МВС 5154', filterForReg: '15' }, 
    
    // Полтавська область
    { seo_val: '12329', text_val: 'РСЦ МВС у Полтавській області',  filterForReg: '16'}, 
    { seo_val: '12330', text_val: 'ТСЦ МВС 5341', filterForReg: '16' }, 
    { seo_val: '12331', text_val: 'ТСЦ МВС 5342', filterForReg: '16' }, 
    { seo_val: '12332', text_val: 'ТСЦ МВС 5343', filterForReg: '16' }, 
    { seo_val: '12333', text_val: 'ТСЦ МВС 5344', filterForReg: '16' }, 
    { seo_val: '12334', text_val: 'ТСЦ МВС 5345', filterForReg: '16' }, 
    { seo_val: '12335', text_val: 'ТСЦ МВС 5346', filterForReg: '16' }, 
    { seo_val: '13175', text_val: 'ТСЦ МВС 5347', filterForReg: '16' }, 
    { seo_val: '13872', text_val: 'ТСЦ МВС 5348', filterForReg: '16' }, 
    
     // Рівненська область
    { seo_val: '12336', text_val: 'РСЦ МВС у Рівненській області', filterForReg: '17' }, 
    { seo_val: '12337', text_val: 'ТСЦ МВС 5641', filterForReg: '17' }, 
    { seo_val: '12338', text_val: 'ТСЦ МВС 5642', filterForReg: '17' }, 
    { seo_val: '12339', text_val: 'ТСЦ МВС 5643', filterForReg: '17' }, 
    { seo_val: '12340', text_val: 'ТСЦ МВС 5644', filterForReg: '17' }, 
    
    // Сумська область
    { seo_val: '12341', text_val: 'РСЦ МВС у Сумській області', filterForReg: '18'}, 
    { seo_val: '12342', text_val: 'ТСЦ МВС 5941', filterForReg: '18'}, 
    { seo_val: '12343', text_val: 'ТСЦ МВС 5942', filterForReg: '18'}, 
    { seo_val: '12344', text_val: 'ТСЦ МВС 5943', filterForReg: '18'}, 
    { seo_val: '12345', text_val: 'ТСЦ МВС 5944', filterForReg: '18'}, 
    { seo_val: '12346', text_val: 'ТСЦ МВС 5945', filterForReg: '18'}, 
    { seo_val: '12347', text_val: 'ТСЦ МВС 5946', filterForReg: '18'},

    //Тернопільська область
    { seo_val: '12348', text_val: 'РСЦ МВС у Тернопільській області', filterForReg: '19'},
    { seo_val: '12349', text_val: 'ТСЦ МВС 6141', filterForReg: '19'},
    { seo_val: '12350', text_val: 'ТСЦ МВС 6142', filterForReg: '19'},
    { seo_val: '12351', text_val: 'ТСЦ МВС 6143', filterForReg: '19'},
    { seo_val: '12352', text_val: 'ТСЦ МВС 6144', filterForReg: '19'},
    { seo_val: '12353', text_val: 'ТСЦ МВС 6145', filterForReg: '19'},

    //Харківська область
    { seo_val: '12354', text_val: 'РСЦ МВС у Харківській області', filterForReg: '20'},
    { seo_val: '12355', text_val: 'ТСЦ МВС 6341', filterForReg: '20'},
    { seo_val: '12356', text_val: 'ТСЦ МВС 6342', filterForReg: '20'},
    { seo_val: '12357', text_val: 'ТСЦ МВС 6343', filterForReg: '20'},
    { seo_val: '12358', text_val: 'ТСЦ МВС 6344', filterForReg: '20'},
    { seo_val: '12359', text_val: 'ТСЦ МВС 6345', filterForReg: '20'},
    { seo_val: '12360', text_val: 'ТСЦ МВС 6346', filterForReg: '20'},
    { seo_val: '12361', text_val: 'ТСЦ МВС 6347', filterForReg: '20'},
    { seo_val: '12362', text_val: 'ТСЦ МВС 6348', filterForReg: '20'},
    { seo_val: '12363', text_val: 'ТСЦ МВС 6349', filterForReg: '20'},
    { seo_val: '13653', text_val: 'ТСЦ МВС 6350', filterForReg: '20'},

    //Херсонська область
    { seo_val: '12364', text_val: 'РСЦ МВС у Херсонській області', filterForReg: '21'},
    { seo_val: '12365', text_val: 'ТСЦ МВС 6541', filterForReg: '21'},
    { seo_val: '12366', text_val: 'ТСЦ МВС 6542', filterForReg: '21'},
    { seo_val: '12367', text_val: 'ТСЦ МВС 6543', filterForReg: '21'},
    { seo_val: '12368', text_val: 'ТСЦ МВС 6544', filterForReg: '21'},
    { seo_val: '12369', text_val: 'ТСЦ МВС 6545', filterForReg: '21'},

    //Хмельницька область
    { seo_val: '12370', text_val: 'РСЦ МВС у Хмельницькій області', filterForReg: '22'},
    { seo_val: '12371', text_val: 'ТСЦ МВС 6841', filterForReg: '22'},
    { seo_val: '12372', text_val: 'ТСЦ МВС 6842', filterForReg: '22'},
    { seo_val: '12373', text_val: 'ТСЦ МВС 6843', filterForReg: '22'},
    { seo_val: '12374', text_val: 'ТСЦ МВС 6844', filterForReg: '22'},
    { seo_val: '12375', text_val: 'ТСЦ МВС 6845', filterForReg: '22'},

    //Черкаська область
    { seo_val: '12376', text_val: 'РСЦ МВС у Черкаській області', filterForReg: '23'},
    { seo_val: '12377', text_val: 'ТСЦ МВС 7141', filterForReg: '23'},
    { seo_val: '12378', text_val: 'ТСЦ МВС 7142', filterForReg: '23'},
    { seo_val: '12379', text_val: 'ТСЦ МВС 7143', filterForReg: '23'},
    { seo_val: '12380', text_val: 'ТСЦ МВС 7144', filterForReg: '23'},
    { seo_val: '12381', text_val: 'ТСЦ МВС 7145', filterForReg: '23'},

    //Чернівецька область
    { seo_val: '12387', text_val: 'РСЦ МВС у Чернівецькій області', filterForReg: '24'},
    { seo_val: '12388', text_val: 'ТСЦ МВС 7341', filterForReg: '24'},
    { seo_val: '12389', text_val: 'ТСЦ МВС 7342', filterForReg: '24'},
    { seo_val: '12390', text_val: 'ТСЦ МВС 7343', filterForReg: '24'},
    { seo_val: '12391', text_val: 'ТСЦ МВС 7344', filterForReg: '24'},
    { seo_val: '12392', text_val: 'ТСЦ МВС 7345', filterForReg: '24'},

    //Чернігівська область
    { seo_val: '12382', text_val: 'РСЦ МВС у Чернігівській області', filterForReg: '25'},
    { seo_val: '12383', text_val: 'ТСЦ МВС 7441', filterForReg: '25'},
    { seo_val: '12384', text_val: 'ТСЦ МВС 7442', filterForReg: '25'},
    { seo_val: '12385', text_val: 'ТСЦ МВС 7443', filterForReg: '25'},
    { seo_val: '12386 ', text_val: 'ТСЦ МВС 7444', filterForReg: '25'},

  ];

  getTSCcode() {
    return this.dataTSCcods;
  }

  constructor() { }
}
